/**
 * -------------------------------------------------------------------------------------------
 * Copyright (c) Microsoft Corporation.  All Rights Reserved.  Licensed under the MIT License.
 * See License in the project root for license information.
 * -------------------------------------------------------------------------------------------
 */
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { customElement, LitElement, property } from 'lit-element';
import { Providers } from '../../Providers';
import { WamProvider } from '../../providers/WamProvider';
/**
 * Authentication Library Provider for Web Account Manager (UWP apps)
 *
 * @export
 * @class MgtWamProvider
 * @extends {LitElement}
 */
let MgtWamProvider = class MgtWamProvider extends LitElement {
    /**
     * Invoked when the element is first updated and performs validation
     *
     * @param {*} changedProperties
     * @memberof MgtWamProvider
     */
    firstUpdated(changedProperties) {
        this.validateAuthProps();
    }
    validateAuthProps() {
        if (this.clientId !== undefined) {
            Providers.globalProvider = new WamProvider(this.clientId, this.authority);
        }
    }
};
__decorate([
    property({ attribute: 'client-id' })
], MgtWamProvider.prototype, "clientId", void 0);
__decorate([
    property({ attribute: 'authority' })
], MgtWamProvider.prototype, "authority", void 0);
MgtWamProvider = __decorate([
    customElement('mgt-wam-provider')
], MgtWamProvider);
export { MgtWamProvider };
//# sourceMappingURL=mgt-wam-provider.js.map